export const IS_WINDOW = 'object' === typeof window
export const ENV = (IS_WINDOW && window.location.href.match(/localhost|ngrok|\.local/gi)) ? 'dev' : 'prod'
export const IS_DEV = ENV == 'dev'
export const API_URL = IS_DEV ? 'http://localhost:8000' : 'https://api.shiftos.app'
